import CustomStore from 'devextreme/data/custom_store';
import query from 'devextreme/data/query';
import {apiRequest} from './async';
import {vars} from '../utils/variables';

const {APP_CODES: {SUCCESS}} = vars;

// --- Загальна фабрика ---
const createCachedStore = ({key = 'ID', loadAll, storeOptions = {}}) => {
  let cache = null;
  let cachePromise = null;

  const ensureCache = async () => {
    if (cache) return cache;
    if (!cachePromise) {
      cachePromise = loadAll().then((items) => {
        cache = items;
        return cache;
      });
    }
    return cachePromise;
  };

  return new CustomStore({
    key,
    loadMode: 'raw',
    load: (loadOptions) => {
      const apply = storeOptions.applyLoad
        ? (items) => storeOptions.applyLoad(items, loadOptions)
        : (items) => items;

      if (cache) return apply(cache);
      return ensureCache().then(apply);
    },
    byKey: (keyValue) => {
      const find = (items) => items.find((item) => String(item[key]) === String(keyValue));
      if (cache) return find(cache);
      return ensureCache().then(find);
    },
  });
};

// --- Допоміжна функція для стандартних запитів ---
const fetchList = async ({operation, data, objectName, mapItem}) => {
  const response = await apiRequest({operation, data});
  if (response.data.ResponseCode === SUCCESS) {
    const items = response.data.Response[objectName] || [];
    return mapItem ? items.map(mapItem) : items;
  }
  return [];
};

// --- Стори ---
export const getMerchantStore = () =>
  createCachedStore({
    loadAll: () => fetchList({
      operation: 'Merchant/List',
      data: {Page: -1, Sorts: ['ID']},
      objectName: 'Merchant',
      mapItem: (m) => ({ID: m.ID, Name: `${m.ID} | ${m.Name}`}),
    }),
  });

export const getPsTypeStore = () =>
  createCachedStore({
    loadAll: () => fetchList({
      operation: 'PaymentSystemType/List',
      data: {Columns: ['ID', 'Name'], Page: -1, Sorts: ['ID']},
      objectName: 'PaymentSystemType',
      mapItem: (ps) => ({ID: ps.ID, Name: `${ps.ID} | ${ps.Name}`}),
    }),
  });

export const getPaymentTypeStore = () =>
  createCachedStore({
    loadAll: () => fetchList({
      operation: 'PaymentType/List',
      data: {Page: -1},
      objectName: 'PaymentType',
    }),
  });

export const getPaymentSystemStore = () =>
  createCachedStore({
    loadAll: () => fetchList({
      operation: 'PaymentSystem/List',
      data: {Columns: ['ID', 'Name', 'PaymentSystemTypeID', 'Status'], Page: -1, Sorts: ['ID']},
      objectName: 'PaymentSystem',
      mapItem: (ps) => ({
        ...ps,
        PaymentSystemTypeID: Number.isFinite(Number(ps.PaymentSystemTypeID)) ? Number(ps.PaymentSystemTypeID) : ps.PaymentSystemTypeID,
        Status: Number.isFinite(Number(ps.Status)) ? Number(ps.Status) : ps.Status,
        Name: `${ps.ID} | ${ps.Name}`,
      }),
    }),
    storeOptions: {
      applyLoad: (items, loadOptions) => {
        let result = items;
        if (loadOptions?.filter) {
          result = query(result).filter(loadOptions.filter).toArray();
        }
        return [...result].sort((a, b) => Number(a.ID) - Number(b.ID));
      },
    },
  });